import { Theme } from "@mui/material";
import { palettes } from "../../../common/themes/palletes";

export const flexRowCont = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyItems: "center",
};

export const mainCont = (theme: Theme) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  height: `calc(100vh - ${theme.mixins.toolbar.minHeight}px)`,
  overflow: "hidden",
  mb: 20,
  px: "15px",
  pb: "15px",
});

export const headerCont = {
  //height: "64px",
  pb: "15px",
  width: "100%",
  alignItems: "start",
  justifyItems: "start",
  pt: { mobile: 2, tablet: 2 },
};

export const child = {
  mainCont: {
    height: "100%",
    width: "100%",
    overflow: "auto",
  },
};

export const moduleItem = {
  border: "1px solid",
  borderColor: palettes.$border,
  borderRadius: "8px",
  mt: "10px",

  header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",

    title: {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
  },
};

export const checkBox = (disabled: boolean, isChecked: boolean) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  width: "21px",
  height: "21px",

  margin: "22px",
  borderRadius: "3px",

  transition: "all 0.1s ease-in-out",
  border: isChecked ? "secondary.main" : "3px solid",
  borderColor: isChecked ? "transparent" : "text.secondary",
  backgroundColor: isChecked ? "secondary.main" : "transparent",
  opacity: disabled ? "50%" : "100%",
  color: "white",
  cursor: "pointer",
});

export const collapsibleIconCont = {
  mr: "10px",
  mt: "5px",
  cursor: "pointer",
};
export const collapsibleIcon = (collapsed: boolean) => ({
  color: collapsed ? "secondary.main" : "primary.main",
  transform: collapsed ? "rotate(-90deg)" : "rotate(90deg)",
  transition: "transform 0.3s ease-in-out",
});

export const privilege = {
  mx: "10px",
  mb: "10px",
  borderRadius: "14px",
  backgroundColor: palettes.$oldAppBg,
};
